import { useMemo, useState } from "react";
import { Blocker, useBlocker } from "react-router-dom";

export type NavigationBlockReturn = {
  dirty: boolean;
  message: string;
  api: {
    setLeaveMessage: (message: string) => void;
    clearLeaveMessage: () => void;
    block: () => void;
    reset: () => void;
  };
  blocker: Blocker;
};

const useNavigationBlock = (): NavigationBlockReturn => {
  const [message, setMessage] = useState("");
  const [dirty, setDirty] = useState(false);
  const blocker = useBlocker(() => dirty);

  const api = useMemo(() => {
    const block = () => {
      setDirty(true);
    };

    const reset = () => {
      setDirty(false);
    };

    const setLeaveMessage = (msg: string) => {
      setMessage(msg);
    };

    const clearLeaveMessage = () => {
      setMessage("");
    };

    return { block, reset, setLeaveMessage, clearLeaveMessage };
  }, []);

  return {
    dirty,
    message,
    api,
    blocker
  };
};

export default useNavigationBlock;
